import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    container: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        flexDirection: 'column',
        backgroundColor: '#ffffff',
        minHeight: '100vh',
        padding: '20px',
        // Add the sunburst background from Figma
        '&::before': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '577px',
            height: '577px',
            background: "radial-gradient(42% 42% at 50% 50%, rgba(255, 240, 152, 0.5) 20%, rgba(255, 255, 255, 0.5) 100%), url('/images/sunburst.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundBlendMode: 'multiply',
            zIndex: 1,
            [theme.breakpoints.up('md')]: {
                transform: 'translate(-15%, -50%)',
            },
        },
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            minHeight: '600px',
            padding: '40px',
        },
    },
    contentWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '40px',
        width: '100%',
        zIndex: 10, // Ensure content is above background
        [theme.breakpoints.up('md')]: {
            gap: '80px',
            width: '50%',
            maxWidth: '400px',
            alignItems: 'flex-start',
        },
    },
    leftContent: {
        paddingLeft: '0',
        textAlign: 'left',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            textAlign: 'left',
        },
    },
    title: Object.assign(Object.assign(Object.assign({}, theme.typography.xl_bold), theme.typographySpacing.xl_bold_sm), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.xxl_bold), theme.typographySpacing.xxl_bold_sm) }),
    subtitle: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.medium_bold_lg), { [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_lg) }),
    description: Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.none),
    freeText: Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.small_regular_sm),
    endText: Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.small_regular_lg),
    wheelContainer: {
        position: 'relative',
        flex: '1',
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'start',
        marginTop: '84px',
        zIndex: 10, // Ensure wheel is above background
        [theme.breakpoints.up('md')]: {
            width: '100%',
            marginTop: 0,
            justifyContent: 'center',
            alignItems: 'center',
        },
    },
    sunburstBackground: {
        position: 'absolute',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'url(/images/sunburst.png) no-repeat',
        zIndex: 1,
        [theme.breakpoints.up('sm')]: {
            width: '400px',
            height: '400px',
        },
        [theme.breakpoints.up('md')]: {
            width: '577px',
            height: '577px',
        },
    },
    spinnerWheel: {
        position: 'relative',
        width: '335px', // Updated to match Figma mobile design
        height: '151px', // Updated to match Figma (151px height)
        border: '2px solid #ff9c55',
        overflow: 'hidden',
        zIndex: 12,
        transition: 'transform 0.1s ease-out',
        transformOrigin: 'center',
        [theme.breakpoints.up('md')]: {
            width: '420px',
            height: '180px',
        },
    },
    spinnerContainer: {
        position: 'relative',
        height: '100%',
        transition: 'none', // Remove default transition, we'll add it via JS
        transform: 'translateY(0px)', // Move up by 60px to center "SPIN TO WIN" with partial visibility of others
        willChange: 'transform', // Optimize for transform animations
    },
    wheelSection: {
        height: '50px', // Updated to match Figma specifications
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: '24px',
        lineHeight: '36px',
        letterSpacing: '0.6px',
        color: '#000000',
        position: 'relative',
        textAlign: 'center',
        padding: '0 4px',
        boxSizing: 'border-box',
        [theme.breakpoints.up('md')]: {
            height: '60px',
            fontSize: '24px',
            lineHeight: '36px',
        },
    },
    notThisTime: {
        backgroundColor: '#f6f6f6',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.3) 50%, rgba(0,0,0,0.1) 100%)',
            pointerEvents: 'none',
            zIndex: 1,
        },
        '& > *': {
            position: 'relative',
            zIndex: 2,
        },
    },
    tapToSpin: {
        backgroundColor: '#fbf5db',
        border: '1px solid #bdbdbd',
        position: 'relative',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        fontWeight: 700,
        '&:hover': {
            transform: 'scale(1.02)',
        },
        '&:active': {
            backgroundColor: '#efe9c1',
            transform: 'scale(0.98)',
        },
    },
    winner: {
        backgroundColor: '#f6f6f6',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(0deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.3) 50%, rgba(0,0,0,0.1) 100%)',
            pointerEvents: 'none',
            zIndex: 1,
        },
        '& > *': {
            position: 'relative',
            zIndex: 2,
        },
    },
    // Active/highlighted states when spinner lands on result
    winnerActive: {
        backgroundColor: '#FFF098', // Green background for winner
        fontWeight: 'bold',
        borderTop: '1px solid #BDBDBD',
        borderBottom: '1px solid #BDBDBD',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: 'none',
            zIndex: 1,
        },
        '& > *': {
            zIndex: 2,
        },
    },
    notThisTimeActive: {
        backgroundColor: '#FFF098', // Red background for lose
        fontWeight: 'bold',
        borderTop: '1px solid #BDBDBD',
        borderBottom: '1px solid #BDBDBD',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: 'none',
            zIndex: 1,
        },
        '& > *': {
            zIndex: 2,
        },
    },
    leftArrow: {
        position: 'absolute',
        left: '0',
        top: 'calc(50% - 24px)',
        transform: 'rotate(180deg)',
        width: '0',
        height: '0',
        borderTop: '24px solid transparent',
        borderBottom: '24px solid transparent',
        borderRight: '24px solid #ff9c55',
        borderTopWidth: spacing.medium,
        borderBottomWidth: spacing.medium,
        borderRightWidth: spacing.medium,
        zIndex: 3,
        [theme.breakpoints.up('md')]: {
            borderTopWidth: spacing.large,
            borderBottomWidth: spacing.large,
            borderRightWidth: spacing.large,
            top: 'calc(50% - 30px)',
            borderTop: `${spacing.large} solid transparent`,
            borderBottom: `${spacing.large} solid transparent`,
            borderRight: `${spacing.large} solid #ff9c55`,
        },
    },
    rightArrow: {
        position: 'absolute',
        right: '0',
        top: 'calc(50% - 24px)',
        transform: 'rotate(180deg)',
        width: '0',
        height: '0',
        borderTop: `${spacing.medium} solid transparent`,
        borderBottom: `${spacing.medium} solid transparent`,
        borderLeft: `${spacing.medium} solid #ff9c55`,
        zIndex: 3,
        [theme.breakpoints.up('md')]: {
            borderTop: `${spacing.large} solid transparent`,
            borderBottom: `${spacing.large} solid transparent`,
            borderLeft: `${spacing.large} solid #ff9c55`,
            top: 'calc(50% - 30px)',
        },
    },
    fadeOverlay: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 15,
        // Single unified overlay that creates the fade effect
        background: `
      linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.8) 0%,
        rgba(255, 255, 255, 0.6) 15%,
        rgba(255, 255, 255, 0) 30%,
        rgba(255, 255, 255, 0) 70%,
        rgba(255, 255, 255, 0.6) 85%,
        rgba(255, 255, 255, 0.8) 100%
      )
    `,
    },
    // Remove the complex overlays and use simpler ones
    topWhiteOverlay: {
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        height: '30px', // Reduced height for better visibility
        background: 'linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.4) 70%, rgba(255,255,255,0) 100%)',
        pointerEvents: 'none',
        zIndex: 16,
    },
    bottomWhiteOverlay: {
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        height: '30px', // Reduced height for better visibility
        background: 'linear-gradient(0deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.4) 70%, rgba(255,255,255,0) 100%)',
        pointerEvents: 'none',
        zIndex: 16,
    },
    closeButton: {
        position: 'absolute',
        top: '16px',
        right: '16px',
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: '#ffffff',
        border: '2px solid #8d6a00',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        zIndex: 20,
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#fbf5db',
            transform: 'scale(1.05)',
        },
        '&:active': {
            transform: 'scale(0.95)',
        },
        '& svg': {
            width: '18px',
            height: '18px',
            stroke: '#8d6a00',
            strokeWidth: 2,
        },
        [theme.breakpoints.down('sm')]: {
            top: '16px',
            right: '16px',
            width: '60px',
            height: '60px',
            '& svg': {
                width: '18px',
                height: '18px',
            },
        },
    },
    shakeAnimation: {
        animation: '$shake 0.5s ease-in-out',
    },
    '@keyframes shake': {
        '0%': { transform: 'translateX(0)' },
        '25%': { transform: 'translateX(-5px)' },
        '50%': { transform: 'translateX(5px)' },
        '75%': { transform: 'translateX(-5px)' },
        '100%': { transform: 'translateX(0)' },
    },
    celebrationOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle, rgba(255,215,0,0.3) 0%, transparent 70%)',
        zIndex: 5,
        opacity: 0,
        transition: 'opacity 0.5s ease',
        '&.show': {
            opacity: 1,
        },
    },
    pulseAnimation: {
        animation: '$pulse 2s infinite',
    },
    '@keyframes pulse': {
        '0%': {
            transform: 'scale(1)',
            boxShadow: '0 0 0 0 rgba(255, 156, 85, 0.7)',
        },
        '70%': {
            transform: 'scale(1.02)',
            boxShadow: '0 0 0 10px rgba(255, 156, 85, 0)',
        },
        '100%': {
            transform: 'scale(1)',
            boxShadow: '0 0 0 0 rgba(255, 156, 85, 0)',
        },
    },
    winningGlow: {
        animation: '$winGlow 1s ease-in-out',
    },
    '@keyframes winGlow': {
        '0%': {
            boxShadow: '0 0 0 0 rgba(255, 215, 0, 0.8)',
        },
        '50%': {
            boxShadow: '0 0 30px 10px rgba(255, 215, 0, 0.6)',
        },
        '100%': {
            boxShadow: '0 0 0 0 rgba(255, 215, 0, 0.8)',
        },
    },
    clickAnimation: {
        animation: '$clickPulse 0.3s ease-out',
    },
    '@keyframes clickPulse': {
        '0%': {
            transform: 'scale(1)',
        },
        '50%': {
            transform: 'scale(1.05)',
        },
        '100%': {
            transform: 'scale(1)',
        },
    },
    spinningIndicator: {
        position: 'absolute',
        top: '50%',
        right: '-50px',
        transform: 'translateY(-50%)',
        width: '30px',
        height: '30px',
        zIndex: 10,
        opacity: 0,
        transition: 'opacity 0.3s ease',
        '&.spinning': {
            opacity: 1,
            animation: '$spin 1s linear infinite',
        },
    },
    '@keyframes spin': {
        '0%': {
            transform: 'translateY(-50%) rotate(0deg)',
        },
        '100%': {
            transform: 'translateY(-50%) rotate(360deg)',
        },
    },
    '@keyframes continuousSpin': {
        '0%': {
            transform: 'translateY(0px)',
        },
        '25%': {
            transform: 'translateY(-45px)', // Slightly offset to make movement clearer
        },
        '50%': {
            transform: 'translateY(-90px)', // Move to second section
        },
        '75%': {
            transform: 'translateY(-135px)', // Between second and third
        },
        '100%': {
            transform: 'translateY(-180px)', // Move to third section and loop
        },
    },
    descriptionCodeText: {
        marginBottom: spacing.small,
    },
    contentContainer: {
        marginBottom: spacing.large,
    },
    tapToSpinOverlay: {
        position: 'absolute',
        top: '60px', // Position over the centered "SPIN TO WIN" section (updated for 60px sections)
        left: '0',
        right: '0',
        height: '60px',
        zIndex: 10,
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tapToSpinWithResult: {
        backgroundColor: '#f6f6f6', // Same grey background as "NOT THIS TIME"
        position: 'relative',
        cursor: 'default',
        fontWeight: 700,
        opacity: 1, // Full opacity when result is present
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.3) 50%, rgba(0,0,0,0.1) 100%)', // Same gradient as "NOT THIS TIME"
            pointerEvents: 'none',
            zIndex: 1,
        },
        '& > *': {
            position: 'relative',
            zIndex: 2,
        },
    },
}));
export default useStyles;
